import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CustomerPaymentModel } from '../../../app-lite/customer-payments/models/customer-payment';

@Component({
  template: require('./customer-payment.actions.component.html')
})
export class CustomerPaymentActionsComponent {
  @Input() record: CustomerPaymentModel;

  @Output() onViewMethodsClick: EventEmitter<CustomerPaymentModel> = new EventEmitter();
  @Output() onEditClick       : EventEmitter<CustomerPaymentModel> = new EventEmitter();
}